export enum ShareType{
    Link = 10,
    Association = 20
}